module.exports = __webpack_public_path__ + "static/media/img-01.d2eafc1b.png";